import WaypointCard from "site-apps/distribution/waypoints/WaypointCard";
import {IconFillingColoured, IconTemperatureColoured} from "site-apps/assets/AssetColorsIcons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const TabPreviewTableAssetsIn = ({assetsIn, points, formData}) => {
    const {t: _CT} = useCustomTranslation(translations);
    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th style={{width: "50px", textAlign: "center"}}>{_CT("route-order")}</th>
                    <th>Contenedor</th>
                    <th></th>
                    <th style={{width: "80px", textAlign: "center"}}>Nivel</th>
                    <th>Motivo</th>
                    <th style={{width: "65px", textAlign: "center"}}>Minutos</th>
                </tr>
            </thead>
            <tbody>
                {points.origin ? (
                    <tr>
                        <td colSpan={6}>
                            <WaypointCard waypoint={points.origin} />
                        </td>
                    </tr>
                ) : (
                    <></>
                )}
                {points.refueling && points.refueling.place === "s" ? (
                    <tr>
                        <td colSpan={5}>
                            <WaypointCard waypoint={points.refueling} />
                        </td>
                        <td className="text-center">{points.refueling.time}</td>
                    </tr>
                ) : (
                    <></>
                )}
                {assetsIn.map((item, index) => (
                    <tr key={index}>
                        <td className="text-center">{item.order}</td>
                        <td>
                            <div>{item.asset.uid} </div>
                            <div className="text-muted">{item.asset.island_id && `(${item.asset.island_name})`}</div>
                            <div>{item.asset.full_address}</div>
                            <small>{item.asset.uuids}</small>
                        </td>
                        <td className="text-end">
                            <div>-</div>
                            <div>
                                <IconTemperatureColoured value={item.asset.temperature} />
                            </div>
                            <div>
                                {item.asset.has_device ? (
                                    <FontAwesomeIcon icon="wifi" title="Tiene sensor" className="text-secondary me-2" />
                                ) : (
                                    <></>
                                )}
                                {item.asset.has_route ? (
                                    <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta" className="text-secondary" />
                                ) : (
                                    <></>
                                )}
                            </div>
                        </td>
                        <td className="text-end">
                            <div>
                                <IconFillingColoured value={item.asset.filling} />
                            </div>
                        </td>
                        <td className="small">{item.reason}</td>
                        <td className="text-center">
                            <div>
                                {item.step}/{item.time}
                            </div>
                            <div>
                                {item.accepted ? (
                                    <FontAwesomeIcon icon="circle" className="text-success" title="Aceptado" />
                                ) : (
                                    <FontAwesomeIcon icon="circle" className="text-danger" title="Rechazado" />
                                )}
                            </div>
                        </td>
                    </tr>
                ))}
                {points.unload ? (
                    <tr>
                        <td colSpan={5}>
                            <WaypointCard waypoint={points.unload} />
                        </td>
                        <td className="text-center">{points.unload.time}</td>
                    </tr>
                ) : (
                    <></>
                )}
                {points.refueling && points.refueling.place === "e" ? (
                    <tr>
                        <td colSpan={5}>
                            <WaypointCard waypoint={points.refueling} />
                        </td>
                        <td className="text-center">{points.refueling.time}</td>
                    </tr>
                ) : (
                    <></>
                )}
                {points.destination ? (
                    <tr>
                        <td colSpan={6}>
                            <WaypointCard waypoint={points.destination} />
                        </td>
                    </tr>
                ) : (
                    <></>
                )}
            </tbody>
        </table>
    );
};
export default TabPreviewTableAssetsIn;
